import React from "react";
import CommingSoon from "../../Components/layouts/comming.soon";

const GrievanceRedressal = () => {
  return <CommingSoon />;
};

export default GrievanceRedressal;
